import PropTypes from 'prop-types';

/**
 * Define reusable prop types.
 */

/** CAMPAIGN FINANCE APP  */
export const MEMBER_SHAPE = {
  chamber: PropTypes.string,
  district: PropTypes.number,
  firstName: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  party: PropTypes.string.isRequired,
};

export const COMPANY_SHAPE = {
  ceo: PropTypes.string.isRequired,
  headquarters: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  logoExists: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  parent: PropTypes.string.isRequired,
};

export const CONTRIBUTIONS_SHAPE = {
  currentCycle: PropTypes.number.isRequired,
  cycles: PropTypes.arrayOf(PropTypes.number).isRequired,
  firstCycle: PropTypes.number.isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  totals: PropTypes.instanceOf(Object).isRequired,
};

/** HOSPITAL PENALTIES APP */
export const PENALTY_SHAPE = {
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired,
};

export const PENALTIES_SHAPE = {
  name: PropTypes.string.isRequired,
  address: PropTypes.string,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  zip: PropTypes.string,
  county: PropTypes.string,
  dataPoints: PropTypes.arrayOf(PropTypes.shape(PENALTY_SHAPE)).isRequired,
};

/** OPIOID APP */
export const OPIOIDS_SHAPE = {
  nmf: PropTypes.string.isRequired,
  hp: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  nml: PropTypes.string.isRequired,
  nmm: PropTypes.string.isRequired,
  rt: PropTypes.number.isRequired,
  pt: PropTypes.number.isRequired,
  pcd: PropTypes.string.isRequired,
  sp: PropTypes.string.isRequired,
  st: PropTypes.string.isRequired,
  sx: PropTypes.string.isRequired,
};
